import type VarietyModel from "Models/Variety";
import { create } from "zustand";
import ApiService from "Helpers/ApiService";

interface VarietyStoreState {
    varieties: VarietyModel[];
    varietiesLoaded: boolean;
    selectedVarietyId: string | undefined;
    fetchVarieties: (forceFetch?: boolean) => Promise<VarietyModel[]>;
    createVariety: (Variety: VarietyModel) => Promise<VarietyModel>;
    updateVariety: (Variety: VarietyModel) => Promise<VarietyModel>;
    deleteVariety: (id: string) => Promise<void>;
}

let varietiesRequest: Promise<VarietyModel[]> | undefined;

export const useVarietyStore = create<VarietyStoreState>((set, get) => ({
    varieties: [],
    varietiesLoaded: false,
    selectedVarietyId: undefined,
    varietyModalOpen: false,
    varietyModalEdit: false,
    fetchVarieties: async (forceFetch?: boolean) => {
        if (get().varietiesLoaded && !forceFetch) return get().varieties;
        if (varietiesRequest) return varietiesRequest;

        varietiesRequest = ApiService.getVarieties().then((varieties: VarietyModel[]) => {
            if (!Array.isArray(varieties)) {
                throw new Error("Unable to load varieties");
            }
            set({ varieties, varietiesLoaded: true });
            return varieties;
        }).finally(() => {
            varietiesRequest = undefined;
        });
        
    
        return varietiesRequest;
    },
    createVariety: async (Variety) => {
        const createdVariety = await ApiService.createVariety(Variety);
        set((state) => ({
            varieties: [...state.varieties.filter((currentVariety) => currentVariety._id !== Variety._id), Variety],
        }));
        return createdVariety;
    },
    updateVariety: async (Variety) => {
        const updatedVariety = await ApiService.updateVariety(Variety);
        set((state) => ({
            varieties: state.varieties.map((currentVariety) =>
                currentVariety._id === Variety._id ? Variety : currentVariety
            ),
        }));
        return updatedVariety;
    },
    deleteVariety: async (id) => {
        await ApiService.deleteVariety(id);
        set((state) => ({
            varieties: state.varieties.filter((Variety) => Variety._id !== id),
            selectedVarietyId: state.selectedVarietyId === id ? undefined : state.selectedVarietyId,
        }));
    },
}));